// Backend'de Client.companyType olarak bu string'ler aynen saklanıyor
export const companyTypeOptions = [
  { value: "LTD Fatura", label: "LTD Fatura" },
  { value: "Şahıs Fatura", label: "Şahıs Fatura" },
  { value: "istisna", label: "istisna" },
  { value: "gider pusulası", label: "gider pusulası" },
  { value: "Serbest Meslek", label: "Serbest Meslek" },
];

// Bu şirket türlerinde influencer fatura yüklemez, sadece bilgi formu doldurur.
export const FORM_COMPANY_TYPES = ["istisna", "gider pusulası"];

export const isFormCompanyType = (companyType) =>
  FORM_COMPANY_TYPES.includes((companyType || "").trim().toLowerCase());

// Sadece "istisna" türünde istisna belgesi yüklenmesi gerekir.
export const isExemptionCompanyType = (companyType) =>
  (companyType || "").trim().toLowerCase() === "istisna";
